import { create } from 'zustand';

interface PointState {
  balance: number;
  lifetime: number;
  toastQueue: Array<{ id: number; amount: number; action: string }>;
  setBalance: (balance: number) => void;
  addToQueue: (amount: number, action: string) => void;
  removeFromQueue: (id: number) => void;
}

let toastId = 0;

export const usePointStore = create<PointState>((set) => ({
  balance: 0,
  lifetime: 0,
  toastQueue: [],
  setBalance: (balance) => set({ balance }),
  addToQueue: (amount, action) =>
    set((state) => ({
      toastQueue: [...state.toastQueue, { id: ++toastId, amount, action }],
    })),
  removeFromQueue: (id) =>
    set((state) => ({
      toastQueue: state.toastQueue.filter((t) => t.id !== id),
    })),
}));
